export default __webpack_public_path__ + "static/media/csi_partners_inactive.06c1b3a5.svg";